import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef
} from "@angular/core";
import { IKeyValueInterface } from "../../shared/config";
import { InvoiceSettingModel } from "../models/invoicing-setting.model";
import { CompanyAddressModel } from "../../company/models/company.model";

@Component({
  selector: "wego-invoicing-setting",
  template: require('../views/invoicing-setting.component.html')
})
export class InvoicingSettingComponent implements OnInit {
  _childCompanyName: string = "";
  _combinedCompanyAddress: string = "";
  companyAddressModel: CompanyAddressModel = new CompanyAddressModel();
  @Input("ErrorModel") errorModel: IKeyValueInterface[];
  @Input("InvoiceSettings") invoiceSettings: InvoiceSettingModel;
  @ViewChild("childCompanyNameElement") childCompanyNameElement: ElementRef;
  @ViewChild("childAddressElement") childAddressElement: ElementRef;

  @Input()
  set childCompanyName(input: string) {
    if (
      !this.childCompanyNameElement.nativeElement.classList.contains("ng-dirty")
    ) {
      this._childCompanyName = input;
      this.invoiceSettings.companyName = this._childCompanyName;
    }
  }
  get childCompanyName() {
    return this._childCompanyName;
  }

  @Input()
  set companyAddress(input: string) {
    if (
      !this.childAddressElement.nativeElement.classList.contains("ng-dirty")
    ) {
      this._combinedCompanyAddress = input;
      this.invoiceSettings.address = this._combinedCompanyAddress;
    }
  }
  get companyAddress() {
    return this._combinedCompanyAddress;
  }
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/invoicing-setting/component/invoicing-setting.component.ts